export default __webpack_public_path__ + "static/media/construction-company-img.9eebd789.jpg";